<template>
  <div>
    <study-request-status-badge
      v-if="valueIsDefined"
      :status="value"
    />
  </div>
</template>

<script>

import Vue from 'vue'
import StudyRequestStatusBadge from '@/modules/clinicalModule/components/StudyRequestStatusBadge'

export default Vue.extend({
    name: 'StudyRequestStatusRenderer',
    components: {
        StudyRequestStatusBadge
    },
    computed: {
        valueIsDefined() {
            return this.params.value !== undefined
        },
        value() {
            if (this.params.isFilterCellRenderer) {
                return this.params.states.find((state) => state.code === this.params.value)
            }
            return this.params.value
        }
    }
})

</script>
